import {HttpClient} from '@angular/common/http'
import {inject, Service, signal} from '@angular/core'
import {environment} from '../../environments/environment'
import {IBankIDVerificationItem} from '../0-application/types'

@Service()
export class DataService {
  /**
   * Holds the userData that we show the user after scanning is done
   */
  public userData = signal<IBankIDVerificationItem>({} as any)

  /**
   * The list of all BankID Verification Data
   */
  public bankIDVerificationItem = signal<IBankIDVerificationItem[]>([])

  private readonly http = inject(HttpClient)

  public getMyTransactions() {
    const url = `${environment.bilAPIUrl}/user`
    return this.http.get<IBankIDVerificationItem[]>(url)
  }

  public checkId(scannedId: string) {
    //const p = 'BANKIDF.D81E468471EC40F7AC1BA5C6DD5A1466.24.B33568F9D6237AF730807FB95052C8DFFE0EE297BC51EC6401A7B82BCEC95621'
    const url = `${environment.bilAPIUrl}/user`
    return this.http.put<IBankIDVerificationItem>(url, scannedId)
  }
}
